import { render, staticRenderFns } from "./FormCongener.vue?vue&type=template&id=635bc06a"
import script from "./FormCongener.vue?vue&type=script&lang=js"
export * from "./FormCongener.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports